import { useRef } from 'react'
import { FiVideo } from 'react-icons/fi'

interface Props {
  url?: string
  title?: string
}

const ThumbVideoWithPreview = ({ url, title }: Props = {}) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const playPromiseRef = useRef<Promise<void> | null>(null)

  const resetVideo = () => {
    const video = videoRef.current
    if (!video) return

    video.pause()
    video.currentTime = 0
  }

  const handleMouseEnter = () => {
    const video = videoRef.current
    if (!video) return

    const playPromise = video.play()
    playPromiseRef.current = playPromise

    playPromise.catch(() => {
      if (playPromiseRef.current !== playPromise) return
      playPromiseRef.current = null
    })
  }

  const handleMouseLeave = () => {
    const playPromise = playPromiseRef.current

    const handlePlaySettled = () => {
      if (playPromiseRef.current !== playPromise) return

      resetVideo()
      playPromiseRef.current = null
    }

    playPromise?.then(handlePlaySettled).catch(handlePlaySettled)
  }

  return url ? (
    <video
      ref={videoRef}
      style={{ width: '12rem' }}
      autoPlay={false}
      muted
      title={title}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <source src={url} type="video/mp4" />
    </video>
  ) : (
    <span className="without-video">
      <FiVideo />
    </span>
  )
}

export default ThumbVideoWithPreview
